import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { request, handleErrors } from "../../../services/helpers";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import classNames from "classnames";

const inputClass =
  "appearance-none block w-full font-display border border-gray-400 rounded py-3 px-4 mb-3 leading-tight focus:outline-none bg-white focus:border-gray-500";

const inputErrorClass = "border border-red-500 b-2 text-red-500";
const labelClass = "block tracking-wide text-black font-display text-sm";

export default function MarketingDialog({ open, handleClose, events }) {
  const [eventsList, setEventsList] = useState([]);
  const [eventForm, setEventForm] = useState({});
  const [currentTab, setCurrentTab] = useState(0);

  useEffect(() => {
    if (events && events.length > 0) {
      setEventsList(events);
      const tempObj = {};
      events.forEach((event) => {
        tempObj[event._id] = {
          youtubeLink: "",
          enableFeedback: false,
        };
      });
      setEventForm(tempObj);
    }
  }, [events]);

  const handleInputChange = (id, value, target) => {
    const tempObj = eventForm;
    if (target === "feedback") {
      tempObj[id].enableFeedback = !tempObj[id].enableFeedback;
    } else {
      tempObj[id].youtubeLink = value;
    }
    setEventForm(tempObj);
  };

  const handleFormSubmission = async () => {
    let formData = eventForm;
    try {
      const res = await request.patch("/event/", formData);
      handleClose();
    } catch (e) {}
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div className="py-8 px-8">
          <button onClick={handleClose} className="font-bold">
            <CloseIcon /> CLOSE
          </button>
        </div>
        <div className="px-8">
          <div className="font-rubik">
            <h3 className="text-xl">Add Marketing To</h3>
            <h1 className="text-4xl font-rubik font-bold leading-10">
              {eventsList[currentTab] && eventsList[currentTab].eventName}
            </h1>
          </div>
        </div>
        {eventsList.map((l, i) => {
          return (
            <div
              key={i}
              className={currentTab === i ? "px-8 py-4" : "px-8 py-4 hidden"}
            >
              <div className="py-4 md:w-7/12 w-full">
                <label className={labelClass}>Youtube link</label>
                <input
                  className={classNames({
                    [inputClass]: true,
                  })}
                  onChange={(e) => {
                    handleInputChange(l._id, e.target.value);
                  }}
                  type="text"
                  placeholder="Event video youtube link"
                />
              </div>
              <div className="flex">
                <div>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      handleInputChange(l._id, e.target.value, "feedback");
                    }}
                  />
                </div>
                <div className="ml-2">
                  <label>Enable Feedback Section</label>
                </div>
              </div>
            </div>
          );
        })}
        <div className="px-8 py-4 pt-8">
          <div className="flex justify-center">
            {eventsList.map((l, i) => (
              <div
                onClick={() => {
                  setCurrentTab(i);
                }}
              >
                <FiberManualRecordIcon
                  className={currentTab === i ? "text-black" : "text-gray-500"}
                />
              </div>
            ))}
          </div>
        </div>
        <hr className="border-b-1 border-gray-500" />
        <div className="px-8 py-4 flex justify-end">
          <div>
            <button
              onClick={handleFormSubmission}
              className="bg-yellow-500 py-4 px-16 rounded font-bold text-sm tracking-widest leading-4 uppercase outline-none"
            >
              SAVE
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
